import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { Row, Col, Button, ButtonGroup } from 'reactstrap';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import PSO from '../../../../services/PSO';
import Strings from '../../../../translations/Translations';

export default function Permissions(props) {
  const { currentIt } = props;

  const { authenticated, toggleLoading } = useAuth();
  const [remixPars, setRemixPars] = useState();

  const modifyPermissions = useCallback(async () => {
    toggleLoading(true);

    try {
      const args = {
        rperm: remixPars.rperm,
        rdmdown: remixPars.rdmdown,
        rpsende: remixPars.rpsende,
        rpsmc: remixPars.rpsmc
      };
      const response = await PSO.modifyRemix({
        un: authenticated.un,
        al: authenticated.al,
        rid: remixPars.rid,
        args
      });

      if (response.result === 'success') {
        toast.success('Success');
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [toggleLoading, authenticated, remixPars]);

  const getPars = useCallback(async () => {
    toggleLoading(true);

    try {
      const response = await PSO.getRemixPars({
        un: authenticated.un,
        al: authenticated.al,
        rid: currentIt.rid
      });

      if (response.result === 'success') {
        if (response.its && response.its[0]) {
          setRemixPars(response.its[0]);
        }
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }

      toggleLoading(false);
    } catch (err) {
      toast.error(Strings('general_error'));
      toggleLoading(false);
    }
  }, [authenticated, currentIt, toggleLoading]);

  useEffect(() => {
    getPars();
  }, [getPars]);

  return (
    <Fragment>
      <Row className="mb-4">
        <Col md={6}>
          <p>{Strings('audience')}</p>
          <ButtonGroup size="lg" className="mb-2">
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rperm !== 'undefined' && parseInt(remixPars.rperm) === 1}
              onClick={() => setRemixPars({ ...remixPars, rperm: 1 })}
            >
              {Strings('only_me')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rperm !== 'undefined' && parseInt(remixPars.rperm) === 2}
              onClick={() => setRemixPars({ ...remixPars, rperm: 2 })}
            >
              {Strings('followers')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rperm !== 'undefined' && parseInt(remixPars.rperm) === 3}
              onClick={() => setRemixPars({ ...remixPars, rperm: 3 })}
            >
              {Strings('public')}
            </Button>
          </ButtonGroup>
        </Col>

        <Col md={6}>
          <p>{Strings('allow_media_download')}</p>
          <ButtonGroup size="lg" className="mb-2">
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rdmdown !== 'undefined' && parseInt(remixPars.rdmdown) === 0}
              onClick={() => setRemixPars({ ...remixPars, rdmdown: 0 })}
            >
              {Strings('yes')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rdmdown !== 'undefined' && parseInt(remixPars.rdmdown) === 1}
              onClick={() => setRemixPars({ ...remixPars, rdmdown: 1 })}
            >
              {Strings('no')}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col md={6}>
          <p>{Strings('permission_to_send_new_media')}</p>
          <ButtonGroup size="lg" className="mb-2">
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsende !== 'undefined' && parseInt(remixPars.rpsende) === 1}
              onClick={() => setRemixPars({ ...remixPars, rpsende: 1 })}
            >
              {Strings('only_me')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsende !== 'undefined' && parseInt(remixPars.rpsende) === 2}
              onClick={() => setRemixPars({ ...remixPars, rpsende: 2 })}
            >
              {Strings('followers')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsende !== 'undefined' && parseInt(remixPars.rpsende) === 3}
              onClick={() => setRemixPars({ ...remixPars, rpsende: 3 })}
            >
              {Strings('public')}
            </Button>
          </ButtonGroup>
        </Col>

        <Col md={6}>
          <p>{Strings('permission_to_send_video_clips')}</p>
          <ButtonGroup size="lg" className="mb-2">
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsmc !== 'undefined' && parseInt(remixPars.rpsmc) === 1}
              onClick={() => setRemixPars({ ...remixPars, rpsmc: 1 })}
            >
              {Strings('only_me')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsmc !== 'undefined' && parseInt(remixPars.rpsmc) === 2}
              onClick={() => setRemixPars({ ...remixPars, rpsmc: 2 })}
            >
              {Strings('followers')}
            </Button>
            <Button
              outline
              color="primary"
              active={remixPars && remixPars.rpsmc !== 'undefined' && parseInt(remixPars.rpsmc) === 3}
              onClick={() => setRemixPars({ ...remixPars, rpsmc: 3 })}
            >
              {Strings('public')}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>

      <Row className='mt-5'>
        <Col md={12}>
          <Button
            color='primary'
            className='btn-wide'
            onClick={modifyPermissions}
          >
            {Strings('save')}
          </Button>
        </Col>
      </Row>
    </Fragment>
  );
}
